import {
  GET_WAREHOUSE_STOCK,
  convertParams,
  convertResult,
} from 'app/common/api/requests/food/warehouse/stock/get'

import { useCommonDataProvider, CommonDataOptions } from 'app/dataProviders/useCommonDataProvider'
import { WarehouseStock, WarehouseStockRequestParams } from 'app/common/types/warehouse/stock'

const defaultState: WarehouseStock = {
  items: [],
  total: 0,
}

type Options = CommonDataOptions<WarehouseStock, WarehouseStockRequestParams>

export function useWarehouseStock(options: Options = {} as Options) {
  const res = useCommonDataProvider({
    ...options,
    requestValue: GET_WAREHOUSE_STOCK,
    error: 'Не удалось получить остатки склада',
    convertions: {
      convertParams,
      convertResult,
    },
    defaultState,
  })

  return res
}
